import { Box, HStack, Circle, Center } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import StepperButtons from "../components/StepperButtons";
import JsonRender from "../JsonRender";
import { useRive, useStateMachineInput } from "@rive-app/react-canvas";

export type IStepperProps = {
  sections: IConfig[][];
  riveSrc?: string;
  riveAnimateInitialState?: number;
  riveAnimationHeight?: string;
  riveAnimationWidth?: string;
  riveAnimationPosition?: "above-explanation" | "below-explanation";
  onChange?: (index: number) => void;
};

export const STATE_MACHINE_NAME = "State Machine 1";

const Stepper = ({
  sections,
  onChange,
  riveSrc,
  riveAnimateInitialState,
  riveAnimationWidth,
  riveAnimationPosition,
  riveAnimationHeight,
}: IStepperProps) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const { rive, RiveComponent } = useRive({
    src: riveSrc,
    stateMachines: STATE_MACHINE_NAME,
    autoplay: true,
  });
  const isPlayingInput = useStateMachineInput(
    rive,
    STATE_MACHINE_NAME,
    "step",
    riveAnimateInitialState ?? 0
  );

  const goToNext = () => {
    if (currentIndex < sections.length - 1) {
      setCurrentIndex((prev) => prev + 1);
    }
  };

  const goToPrev = () => {
    if (currentIndex > 0) {
      setCurrentIndex((prev) => prev - 1);
    }
  };

  const handleDotClick = (index: number) => {
    setCurrentIndex(index);
  };

  useEffect(() => {
    if (onChange) {
      onChange(currentIndex);
    }
  }, [currentIndex]);

  useEffect(() => {
    if (isPlayingInput) {
      isPlayingInput.value = (riveAnimateInitialState ?? 0) + currentIndex;
    }
  }, [currentIndex, riveAnimateInitialState, rive, isPlayingInput]);

  const riveAnaimtion = (
    <Center>
      <RiveComponent
        style={{
          width: riveAnimationWidth ?? "100%",
          height: riveAnimationHeight ?? "15rem",
        }}
      />
    </Center>
  );

  console.log(sections, "---sections");

  return (
    <Box flexDirection="column" mx="auto" width={"100%"}>
      {/* Render the current section */}

      {riveSrc &&
        (riveAnimationPosition === "above-explanation" ||
          !riveAnimationPosition) &&
        riveAnaimtion}

      <Box flex="1" minHeight="0" overflowY="auto" position="relative">
        {sections &&
          sections.map((elems, eidx) => (
            <Box display={currentIndex === eidx ? "block" : "none"} key={eidx}>
              <JsonRender content={elems} mode={"view"} />
            </Box>
          ))}
      </Box>

      {riveSrc &&
        riveAnimationPosition === "below-explanation" &&
        riveAnaimtion}

      {/* Stepper section - fixed height */}
      <HStack justifyContent="center" spacing={2} mb={2}>
        {(sections || []).map((_, index) => (
          <Circle
            key={index}
            size="10px"
            bg={currentIndex === index ? "white" : "neutral.700"}
            cursor="pointer"
            onClick={() => handleDotClick(index)}
          />
        ))}
      </HStack>

      {/* Navigation buttons */}
      {sections && (
        <StepperButtons
          onPrevClick={goToPrev}
          onPrevIsDisabled={currentIndex === 0}
          onNextClick={goToNext}
          onNextIsDisabled={currentIndex === sections.length - 1}
        />
      )}
    </Box>
  );
};

export default Stepper;
